import { configureStore, createSlice } from '@reduxjs/toolkit'

// Simple app slice to prevent Redux warnings
const appSlice = createSlice({
  name: 'app',
  initialState: {
    isLoading: false,
    theme: 'light'
  },
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload
    },
    setTheme: (state, action) => {
      state.theme = action.payload
    }
  }
})

export const { setLoading, setTheme } = appSlice.actions

// Store configuration
export const store = configureStore({
  reducer: {
    app: appSlice.reducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
